import Mock from 'mockjs'

const {page} = require('../util');

const qs = require('qs');
const {receiveList, receiveDataDetail} = require('./data');

Mock.mock('/datareceive/list', 'post', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    bodyObject.data = page(receiveList, bodyObject);
    bodyObject.total = receiveList.length;
    return {
        code: 200,
        body: bodyObject,
    }
});

Mock.mock('/datareceive/detail', 'post', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    bodyObject.data = page(receiveDataDetail, bodyObject);
    bodyObject.total = receiveDataDetail.length;
    return {
        code: 200,
        body: bodyObject,
    }
});
